import { connect } from 'react-redux'
import { loadImis, loadNewsHome } from '../../actions/home'
import { PageConsultancyAndResearch } from './PageConsultancyAndResearch.component'

const mapStateToProps = (state) => {
  return {
    news: state.home.news,
    imis: state.home.imis,
  }
}

const mapDispatchToProps = (dispatch) => ({
  didMount: () => {
    dispatch(loadImis(12))
    dispatch(loadNewsHome())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageConsultancyAndResearch)


// WEBPACK FOOTER //
// ./src/features/PageConsultancyAndResearch/PageConsultancyAndResearch.container.js